module.exports = __webpack_public_path__ + "static/media/assessment.50a5439e.svg";